export default {
  title: 'Yritystiedot',
  subtitle: 'Tämä näkyy verkkokauppasi ja Storefrontisi alatunnisteessa vasta, kun tallennat sen.',
  card_title: 'Yritystiedot',
  placeholder: 'Kirjoita yritystietosi',
  status: {
    saved: 'Tallennettu',
    not_shown: 'Ei vielä näy kaupassasi tai Storefrontissasi',
    unsaved: 'Tallentamattomia muutoksia — kauppasi ja Storefrontisi näyttävät viimeksi tallennetun version',
  },
  save: 'Tallenna',
  retry: 'Yritä uudelleen',
  preview: {
    title: 'Alatunnisteen esikatselu (kauppa ja Storefront)',
    terms: 'Ehdot',
    privacy: 'Tietosuoja',
    cookies: 'Evästeet',
    imprint: 'Yritystiedot',
  },
  toasts: {
    saved: 'Yritystiedot tallennettu',
    save_failed: 'Yritystietojen tallennus epäonnistui. Yritä uudelleen.',
    load_failed: 'Yritystietojen lataus epäonnistui. Lataa sivu uudelleen.',
  },
};
